import Button from 'meinian-package/src/baseComponent/button'
import React from 'react'
import { useParams } from 'react-router-dom'
import setFolder from '../../../../component/useFunModal/setFolder'

/**
* 新建文件夹 按钮
*/
export default
function BtnAddFolder({ onClick }) {
  const { folderId } = useParams()
  return <Button
    type="primary"
    onClick={() => setFolder({
      value: { parentId: folderId },
      title: '新建文件夹',
      onOk: onClick
    })}
  >新建文件夹</Button>
}
